import { useMutation } from "@tanstack/react-query";
import { API_PAYMENT } from "../apis";

export const usePostBooking = () => {
    const { mutate, isSuccess, error } = useMutation<any, Error, any>({
        mutationFn: (formData) => API_PAYMENT.postPaymentBooking(formData),
        mutationKey: ["POST_BOOKING"],
        onError: () => {
            alert("통신 에러 발생 ! 다시 결제를 시도 해주세요.");
        },
    });

    return { isSuccess, error, mutate };
};
